<script>
  import { onMount, onDestroy } from 'svelte';
  import { fade } from 'svelte/transition';

  import { writable } from 'svelte/store';
  import settings from '../../config';
  import session from '../../lib/session';
  import {
    init_synchronization,
    init_synchronization_debug,
    remove_syncronization,
  } from '../../lib/synchronize';
  import {
    init_translations,
    init_debug_translations,
  } from '../../lib/translate.js';
  import { url_for } from '../../lib/utils';
  import { init_router } from './router.js';
  import APIClient from '../../state-charts/api-client';
  import Layout from './Layout.svelte';
  import WP from '../state-store.js';

  let route_name = writable('/home');
  window.loading = false;
  let branding_init = false;
  let app_init = false;

  let bg_orderer;
  let bg_worker;
  let language_init = false;

  // initializer functions --------------------------------------------------- //

  const load_profile = async () => {
    await APIClient.get_profile();
  };

  const init_debug_vars = () => {
    WP.client = APIClient;
    WP.session = $session;
    WP.settings = settings;

    window.wp = WP;

    init_debug_translations();
  };

  const handle_version_updates = async e => {
    window.location.reload();
  };

  // TODO: check if this is still needed
  const maintain_route_name = e => {
    $route_name = e.detail.path;
  };

  // reactive functions ------------------------------------------------------- //

  $: if (
    ($session?.language || navigator.language) &&
    $session?.user &&
    !language_init
  ) {
    init_translations(session);
    language_init = true;
  }

  // initialization ----------------------------------------------------------- //

  const init_app = async () => {
    APIClient.init();

    try {
      // init_synchronization_debug();
      await init_synchronization(APIClient.reload_session_data);
    } catch (e) {
      console.log(e);
    }

    window.addEventListener(
      'wp:api:versionupdateneeded',
      handle_version_updates
    );

    await load_profile();

    window.addEventListener('wp:router:beforenavigation', maintain_route_name);

    init_router();

    if ($session && window && settings.env !== 'production') {
      init_debug_vars();
    }
    app_init = true;
  };

  onMount(async () => {
    await init_app();
  });

  $: if ($session?.merchant?.merchant_uuid && !branding_init && app_init) {
    (async () => {
      await APIClient.inject_branding($session.merchant.merchant_uuid);
      branding_init = true;
    })();
  }

  $: if ($session?.branding?.vars && app_init) {
    bg_orderer = `${settings.api_host}${$session.branding.vars.orderer_background_image_url}`;
    bg_worker = `${settings.api_host}${$session.branding.vars.worker_background_image_url}`;

    document.getElementById(
      'bg-branding'
    ).style.backgroundImage = `url('${bg_orderer}')`;
  }

  $: if ($session?.user?.last_role && $session?.branding?.vars && app_init) {
    if ($session.user.last_role === 'orderer') {
      bg_orderer = `${settings.api_host}${$session.branding.vars.orderer_background_image_url}`;
      document.getElementById(
        'bg-branding'
      ).style.backgroundImage = `url('${bg_orderer}')`;
    } else {
      bg_worker = `${settings.api_host}${$session.branding.vars.worker_background_image_url}`;
      document.getElementById(
        'bg-branding'
      ).style.backgroundImage = `url('${bg_worker}')`;
    }
  }

  onDestroy(() => {
    remove_syncronization();
    window.removeEventListener(
      'wp:api:versionupdateneeded',
      handle_version_updates
    );
    window.removeEventListener(
      'wp:router:beforenavigation',
      maintain_route_name
    );
  });
</script>

<div id="bg-branding" />

<Layout {route_name}>
  <div
    slot="content"
    id="auth-app"
    style="overflow-y: scroll; padding-bottom: 55px; height: 100vh;" />
</Layout>

<div id="aside_tooltips" />
<div
  id="loading-layer"
  class:hidden={window.loading === false}
  style="width: 100%; height: 100%; background-color: black; opacity: .5;
  position: fixed; z-index: 9999;">
  <div class="lds-spinner">
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
</div>

<!--</div>-->
<!--</Layout>-->

<style>
  #bg-branding {
    background-size: cover;
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    transition: all 0.3s ease;
  }
  .top-menu {
    height: 50px;
    width: 90%;
    position: absolute;
    right: 30px;
  }

  .side-menu {
    background-color: var(--orderer-background-color);
    width: 50px;
    position: absolute;
    left: 30px;
    height: 93%;
  }

  .material-icons {
    color: var(--orderer-background-color) !important;
  }
</style>
